const Year51 = [
    {id: "1", value: "1年"},    
    {id: "2", value: "2年"},
    {id: "3", value: "3年"},
    {id: "4", value: "4年"},
    {id: "5", value: "5年"},
    {id: "6", value: "6年"}    
  ];  
  
  export default Year51  